<template>
  <div>
    <Loader :value="promise" :delay="0" theme="overlay" class="virtual-category-content__items">
      <Tree
        v-for="(item, index) in items"
        :value="value"
        @input="$ev => $emit('input', $ev)"
        :key="index"
        :item="item"
        @create="$ev => $emit('create', $ev)"
        class="virtual-category-content__item"
      />
      <Create :placeholder="$t('addCategory') + '...'" :create="true" @create="$ev => $emit('create', $ev)" />
    </Loader>
    <div class="virtual-category-content__input">
      <div class="virtual-category-content__input-label">{{ $t('selected') }}:</div>
      <CategoryInput :value="value" placeholder />
    </div>
  </div>
</template>

<script>
import Tree from './Tree'
import CategoryInput from './Input'
import Create from './Create'

export default {
  props: {
    items: [String, Array, Function],
    value: String,
    promise: Promise,
    disableSort: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    CategoryInput,
    Tree,
    Create,
  },
}
</script>

<style lang="scss">
.virtual-category-content {
  &__input {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    font: inherit;
    width: 100%;
    padding: 1.1em;
    background-color: css-alpha('border-color', 0.5);
    border-radius: var(--border-radius);

    &-label {
      font-weight: bold;
      flex-shrink: 0;
      margin-right: 1rem;
    }
  }
  &__items {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
  }
}
</style>
